<template>
  <div class="share-panel" v-click-outside="closePanel" >
    <div class="popup-title">{{t('share_indicator')}}</div>
    <div class="indicator-name">{{t(values.indicator)}}</div>
    <div class="text" v-html="values.text"></div>
    <div class="close-button" @click="closePanel"></div>
    <div class="lower-info">
      <div class="share-buttons">
        <ShareNetwork
          network="facebook"
          :url="shareURL"
          :title="values.text"
          :quote="values.text"
        >
          <div class="share-button"><span class="share-icon fb"></span>Facebook</div>
        </ShareNetwork>
        <ShareNetwork
            network="twitter"
            :url="shareURL"
            :title="values.text"
            :text="values.text"
          >
            <div class="share-button"><span class="share-icon tw"></span>Twitter</div>
        </ShareNetwork>
        <ShareNetwork
            network="linkedin"
            :url="shareURL"
            :title="values.text"
            :text="values.text"
          >
            <div class="share-button"><span class="share-icon linkedin"></span>LinkedIn</div>
        </ShareNetwork>
        <ShareNetwork
            network="whatsapp"
            :url="shareURL"
            :title="values.text"
            :text="values.text"
            v-if="isMobile"
          >
            <div class="share-button"><span class="share-icon whatsapp"></span>WhatsApp</div>
        </ShareNetwork>
      </div>
      <div class="copy-link-container">
        <div class="label">Copiar link</div>
        <div class="copy-input">
          <input type="text" ref="copyInput" disabled :value="shareURL">
          <div class="copy-button" @click="copyToClipboard">Copiar</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: "SharePanel",
  props: ['values'],
  computed: {
    baseURL () {
      return this.$store.state.shareURL
    },
    shareURL () {
      /*debugger
      let query =  this.$route.query
      let qs = Object.keys(query)
      .map(key => `${key}=${query[key]}`)
      .join('&')*/

      //TODO: Replace window-location with url passed from IFRAME
      return this.$store.state.shareURL
        + '?fullPath=' + encodeURIComponent(this.$route.fullPath)
        //+ '&query=' + encodeURIComponent(qs)
    }
  },
  methods: {
    closePanel (){
      this.$emit('close')
    },
    copyToClipboard () {
      this.$clipboard(this.shareURL)
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="stylus" scoped>
.share-panel
  .popup-title
    m-font-size(18, 30)
    margin-bottom: vh(20px)
  .indicator-name
    font-family 'Anton'
    // text-transform: uppercase
    m-font-size(22, 30)
    letter-spacing: 0.25px;
    margin-bottom: vh(15px)
  .text
    m-font-size(22, 30)
    text-align left !important
    margin-bottom: vh(40px)
    .mobile &
      m-font-size(20, 28)
      margin-bottom: vh(25px)
    >>> .text-value
      text-decoration none
      color $bs-blue
  .lower-info
    display flex
    text-align left
    align-items: flex-end
    .mobile &
      flex-direction column
      justify-content center
    .share-buttons
      display flex
      justify-content center
      margin-top 15px
      .mobile &
        margin-bottom: vh(25px)
        width: 100%
        justify-content: space-around
      .share-button
        display flex
        flex-direction column
        align-items center
        cursor pointer
        font-family: 'Lato'
        font-size 11px
        font-weight $fw-semi-bold
        margin-right: vw(25px)
        .mobile &
          margin-right 0px
        .share-icon
          background-size contain
          background-repeat: no-repeat;
          background-position: center center;
          height vw(45px)
          width vw(45px)
          margin-bottom 5px
          &.fb
            background-image url('~@/assets/icons/share-fb.svg')
          &.tw
            background-image url('~@/assets/icons/share-twitter.svg')
          &.linkedin
            background-image url('~@/assets/icons/share-linkedin.svg')
          &.whatsapp
            background-image url('~@/assets/icons/share-whatsapp.svg')

    .copy-link-container
      flex 1 1 auto
      .mobile &
        width 100%
      .label
        font-family: 'Lato'
        font-size 11px
        font-weight $fw-semi-bold
        margin-bottom 5px
      .copy-input
        display flex
        input
          flex 1 1 auto
          border none
          border-radius 0px
          height 35px
          background #F4F4F4
          color #000
          font-family: 'Lato'
          m-font-size(14, 17)
          padding-left 5px
        .copy-button
          cursor pointer
          display flex
          height 35px
          justify-content center
          align-items center
          min-width 110px
          background $bs-blue
          text-transform uppercase
          color #fff
          font-family: 'Lato'
          m-font-size(14, 17)
          font-weight $fw-bold



</style>